import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../node_modules/dygraphs/dist/dygraph.css';

import { createMuiTheme } from '@material-ui/core/styles';

import PrivateApp from './root/private/App';
import PublicApp from './root/public/App';
import ThemeColor from './common-components/ThemeColors';
import registerServiceWorker from './registerServiceWorker';
import { isLoggedIn, getUserId } from './helpers/common';
import configureStore from './redux-store/configureStore';

import { loadUserData } from './system/action-creator';

const serisTheme = createMuiTheme({
  palette: {
    primary: {
      main: ThemeColor.primary,
      dark: ThemeColor.primary,
    },
    secondary: {
      main: "#fff"
    }
  },
  typography: {
    useNextVariants: true,
  }
});

const store = configureStore();

export const renderApp = () => {
  if (isLoggedIn()) {
    ReactDOM.render(<PrivateApp theme={serisTheme} store={store} />, document.getElementById('root'));
  }
  else {
    ReactDOM.render(<PublicApp theme={serisTheme} store={store} />, document.getElementById('root'));
  }
}

setTimeout(() => {
  if (isLoggedIn()) {
    loadUserData(getUserId(), renderApp)(store.dispatch);
  } else
    renderApp();
}, 1000);

registerServiceWorker();
